import React from "react";
import { useUser } from "src/business-types/grocery/components/UserContext";
import { Getdata } from "src/shared/services/interface";
import { formatNumber } from "../../OrderSearch";

interface Props {
  orderId: string;
  customerName: string;
  order: Getdata | undefined;
}

const OrderCustomerInfo: React.FC<Props> = ({ orderId, customerName, order }) => {
  const { userConfigration } = useUser();
  const toBoolean = (value: any) => value === true || value === "true";
  const billNoEnabled = toBoolean(userConfigration?.billNoEnabled);
  const orderIdEnabled = toBoolean(userConfigration?.orderIdEnabled);

  return (
    <div className='-mb-2'>
      <div className='flex justify-between w-full'>
        {/* Show ORDER ID only if enabled */}
        {orderIdEnabled && (
          <h4 className='w-1/2'>ORDER ID: {orderId}</h4>
        )}
        
        {/* Show Bill No only if enabled */}
        {billNoEnabled && (
          <div className={`${orderIdEnabled ? 'w-1/2' : 'w-full'} flex ${orderIdEnabled ? 'justify-center' : 'justify-start'}`}>
            <h2>Bill No. :</h2> 
            {order?.billNumber ? <p>{formatNumber(order?.billNumber)}</p> : <p>N/A</p>}
          </div>
        )}
      </div>
      
      {/* If both are disabled, show a message or empty state */}
      {!orderIdEnabled && !billNoEnabled && (
        <div className='text-sm text-gray-500 mb-2'>
          No billing information available
        </div>
      )}
      
      <div className='flex'>
        <h3 className='text-xl font-bold'>Name</h3>
        <h3 className='text-xl font-bold'>: {customerName}</h3>
      </div>
    </div>
  );
};

export default OrderCustomerInfo;